import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { get, save } from "../requests/therapy";
import { createSignal, onMount } from "solid-js";
import { useNavigate } from "@solidjs/router";

export default function useTherapyForm() {

  const navigate = useNavigate();

  const [loading, setLoading] = createSignal(false);
  const [key, setKey] = createSignal(null);
  const [form, setForm] = createStore({
    name: "",
    description: "",
    targetConditions: "",
    duration: 0,
  });

  const fetchInfo = async (pid) => {
    setLoading(true);
    setKey(pid);
    try {
      const data = await get(key());
      setForm('name', data.entity.name);
      setForm('description', data.entity.description);
      setForm('targetConditions', data.entity.targetConditions);
      setForm('duration', data.entity.duration);
    } catch (error) {
      throw error;
    }  finally {
      setLoading(false);
    }
  }

  const { successToast, errorToast } = useApplication();

  const handleInput = (ev) => {
    setForm([ev.currentTarget.name], ev.currentTarget.value);
  };

  const handleChange = (name, value) => {
    setForm([name], value);
  };


  const handleSave = async (ev) => {
    ev.preventDefault();
    setLoading(true);
    try {

      const formData = new FormData();
      Object.keys(form).forEach(key => formData.append(key, form[key]));

      if (key() !== null) {
        formData.append('id', key());
      }

      const data = await save(formData);

      if (data.success) {
        successToast(data.message);
        navigate("/therapies");
        return;
      }

      errorToast(data.messages);
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };

  onMount(async () => {
  })

  return {
    loading,
    form,
    fetchInfo,
    handleSave,
    handleInput,
    handleChange
  };
}
